import * as React from 'react';
import './App.css';

import { Switch, Route } from 'react-router';
import Login from './Components/People/Login';
import StorageUtils from './server/utils/storage-utils';
import ForgetPassword from './Components/People/ForgetPassword';
import LoginFromApp from './Components/People/LoginFromApp';
import RegisterUser from './Components/People/RegisterUser';

interface Props {

}
interface State {

}
class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {

    }
  }

  componentDidMount() {
  }

  public render() {

    return (

      <div className="wrapper">

        <Switch>

          <Route exact
            path={"/"}
            component={((url) => {
              return (
                <Login instance={""} verifyOTP={StorageUtils.getItem('user') &&
                  StorageUtils.getItem('verifyOTP') && StorageUtils.getItem('verifyOTP') == "1"} />
              )
            })}
          />

          <Route exact
            path={"/:Instance"}
            component={((url) => {
              const instance = url.match.params.Instance;
              return (
                <Login instance={instance} verifyOTP={StorageUtils.getItem('user') &&
                  StorageUtils.getItem('verifyOTP') && StorageUtils.getItem('verifyOTP') == "1"} />
              )
            })}
          />

          <Route exact
            path={"/:Instance/:forget-password"}
            component={((url) => {
              const instance = url.match.params.Instance;
              return (
                <Login forgetPassword={true} instance={instance} verifyOTP={StorageUtils.getItem('user') &&
                  StorageUtils.getItem('verifyOTP') && StorageUtils.getItem('verifyOTP') == "1"} />
              )
            })}
          />

          <Route exact
            path={"/:Instance/LoginInMobileApp/:user/:password"}
            component={((url) => {
              const instance = url.match.params.Instance;
              const user = url.match.params.user;
              const password = url.match.params.password + (url.location.hash !== "" ? url.location.hash : '')
              return (
                <LoginFromApp instance={instance} user={user} password={password} />
              )
            })}
          />

          <Route exact
            path={"/:Instance/:change-password/:key"}
            component={((url) => {
              const instance = url.match.params.Instance;
              const key = url.match.params.key;
              return (
                <ForgetPassword instance={instance} loginKey={key} />
              )
            })}
          />

          <Route exact
            path={"/:Instance/Register"}
            component={((url) => {
              const instance = url.match.params.Instance;
              return (
                <RegisterUser instance={instance} />
              )
            })}
          />

        </Switch>
      </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx